module.exports = __webpack_public_path__ + "media/img/frontend_application/christmas/fortune-wheel-bb46fbf9f945092cae423f4712bd9380.png";